import ButterImage from '../../components/ButterImage'

type OurBenefitsProps = {
  readonly title: string
  readonly benefits: ReadonlyArray<{
    readonly logo: string
    readonly logoDescription: string
    readonly description: string
  }>
}

export default function OurBenefits({ title, benefits }: OurBenefitsProps) {
  return (
    <section>
      <div style={{ display: 'flex', gap: 20 }}>
        <h2>{title}</h2>

        <ul style={{ listStyle: 'none', display: 'flex', gap: 20 }}>
          {benefits.map(({ logo, logoDescription, description }) => {
            return (
              <li key={description}>
                <ButterImage src={logo} alt={logoDescription} width={30} height={30} />

                <p>{description}</p>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}
